function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { SvgIcon } from '@material-ui/core';
export default function ParkingMeterIcon(props) {
  let output = /*#__PURE__*/React.createElement(SvgIcon, _extends({
    viewBox: "0 0 1024 1024"
  }, props), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M694.724 312.818c-11.636-90.472-89.138-160.602-182.724-160.602-93.584 0-171.088 70.128-182.726 160.602h152.42v-95.182h60.612v95.182h152.418z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M525.274 489.26h-24.79v44.448h24.79c12.244 0 22.204-9.98 22.204-22.224s-9.96-22.224-22.204-22.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M512 0c-196.706 0-356.762 160.036-356.762 356.742 0 76.554 51.176 201.292 152.176 370.926h409.172c101-169.632 152.176-294.372 152.176-370.926 0-196.706-160.056-356.742-356.762-356.742zM525.274 594.322h-24.79v84.472h-60.612v-250.146h85.402c45.662 0 82.816 37.156 82.816 82.836 0 45.682-37.154 82.838-82.816 82.838zM756.548 345.004l-1.758 28.426h-485.582l-1.758-28.426c-0.202-3.172-0.302-5.98-0.302-8.566 0-135.004 109.85-244.832 244.852-244.832s244.852 109.83 244.852 244.832c0 2.586-0.102 5.374-0.304 8.566z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M354.55 788.28v83.524h67.184v152.196h180.532v-152.196h67.184v-83.524z"
  })));
  return output;
}
